import { useTranslation } from 'react-i18next';
import { achievementGoals } from '@/mocks/skillsData';

const DOMAIN_COUNT = 5;
const COURSE_COUNT = 3;

export default function AchievementGoals() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-100/60">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-12">
          {String(t('skills.goals.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('skills.goals.title')}
          </h2>
          {String(t('skills.goals.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
          {String(t('skills.goals.description')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-500 tracking-[0.04em] leading-relaxed mt-5 max-w-[650px] mx-auto">{__s}</p>))}
        </div>

        <div className="space-y-6">
          {Array.from({ length: DOMAIN_COUNT }, (_, dIdx) => (
            <div key={dIdx} className="bg-background-50 border border-background-200/60 p-5 md:p-6">
              <p className="font-heading text-[16px] text-foreground-800 tracking-[0.05em] mb-4">
                {t(`skills.goals.domain.${dIdx}`)}
              </p>
              <div className="space-y-3">
                {Array.from({ length: COURSE_COUNT }, (_, cIdx) => {
                  const domain = achievementGoals.domains[dIdx];
                  const course = achievementGoals.courses[cIdx];
                  const value = course.values[domain.key as keyof typeof course.values];
                  return (
                    <div key={cIdx} className="flex items-center gap-4">
                      <span className="text-[14px] text-foreground-500 tracking-[0.04em] w-[90px] flex-shrink-0 whitespace-nowrap">
                        {t(`skills.goals.course.${cIdx}`)}
                      </span>
                      <div className="flex-1 bg-background-200/60 h-2.5 relative">
                        <div
                          className={`h-full transition-all duration-700 ${course.color}`}
                          style={{ width: `${value}%` }}
                        ></div>
                      </div>
                      <span className="text-[14px] text-foreground-600 tracking-[0.04em] w-9 text-right font-medium">
                        {value}%
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {String(t('skills.goals.footerNote')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-center text-[13px] text-foreground-400 tracking-[0.03em] mt-8">{__s}</p>))}
      </div>
    </section>
  );
}
